<div [ngClass]="wayfinderClass">
  <p class="wayfinder__title" data-automation-id="wayfinder-header">
    What can we help you with today?
  </p>
  <div class="wayfinder__form">
    <div class="dropdowns">
      <div
        #whoDropdown
        [ngClass]="[
          'dropdown',
          'dropdown_is-active',
          steps['WHO'].isDropdownOpen ? 'dropdown_open' : '',
          steps['WHO'].selectedOption ? 'dropdown_has-value' : ''
        ]"
        (click)="toggleDropdown('WHO')"
        (keyup)="onKeyUp($event, 'WHO')"
        tabindex="0"
        data-automation-id="wayfinder-first-dropdown"
      >
        <label class="dropdown__label" for="">Who Are You?</label>
        <p
          [ngClass]="[
            'dropdown__selected-label',
            steps['WHO'].selectedOption
              ? 'dropdown__selected-label_visible'
              : ''
          ]"
          [innerHtml]="cleanHtml(steps['WHO'].selectedOption?.term)"
        ></p>
        <ul class="dropdown__list" (click)="$event.stopPropagation()">
          <ng-container *ngFor="let data of wayfinderMatrixJson">
            <li
              *ngIf="!data.parent_target_id"
              class="dropdown__list-item"
              (click)="selectOption('WHO', data)"
              (mouseenter)="steps['WHO'].hoveredOption = data"
              (mouseleave)="steps['WHO'].hoveredOption = null"
              [innerHtml]="cleanHtml(data.term)"
            ></li>
          </ng-container>
        </ul>
      </div>

      <div
        #serviceDropdown
        [ngClass]="[
          'dropdown',
          steps['SERVICE'].isDropdownOpen ? 'dropdown_open' : '',
          steps['SERVICE'].selectedOption ? 'dropdown_has-value' : '',
          steps['WHO'].selectedOption ? 'dropdown_is-active' : ''
        ]"
        (click)="steps['WHO'].selectedOption && toggleDropdown('SERVICE')"
        [tabindex]="steps['WHO'].selectedOption ? 0 : -1"
        (keyup)="onKeyUp($event, 'SERVICE')"
        data-automation-id="wayfinder-second-dropdown"
      >
        <label class="dropdown__label" for="">What Service Do You Need?</label>
        <p
          [ngClass]="[
            'dropdown__selected-label',
            steps['SERVICE'].selectedOption
              ? 'dropdown__selected-label_visible'
              : ''
          ]"
          [innerHtml]="cleanHtml(steps['SERVICE'].selectedOption?.term)"
        ></p>
        <ul class="dropdown__list" (click)="$event.stopPropagation()">
          <ng-container *ngFor="let data of wayfinderMatrixJson">
            <li
              *ngIf="data.parent_target_id === steps['WHO'].selectedOption?.tid"
              class="dropdown__list-item"
              (click)="selectOption('SERVICE', data)"
              (mouseenter)="steps['SERVICE'].hoveredOption = data"
              (mouseleave)="steps['SERVICE'].hoveredOption = null"
              [innerHtml]="cleanHtml(data.term)"
            ></li>
          </ng-container>
        </ul>
      </div>

      <div
        #lookingForDropdown
        [ngClass]="[
          'dropdown',
          steps['LOOKING_FOR'].isDropdownOpen ? 'dropdown_open' : '',
          steps['LOOKING_FOR'].selectedOption ? 'dropdown_has-value' : '',
          steps['SERVICE'].selectedOption ? 'dropdown_is-active' : ''
        ]"
        (click)="
          steps['SERVICE'].selectedOption && toggleDropdown('LOOKING_FOR')
        "
        [tabindex]="steps['SERVICE'].selectedOption ? 0 : -1"
        (keyup)="onKeyUp($event, 'LOOKING_FOR')"
        data-automation-id="wayfinder-third-dropdown"
      >
        <label class="dropdown__label" for="">What Are You Looking For?</label>
        <p
          [ngClass]="[
            'dropdown__selected-label',
            steps['LOOKING_FOR'].selectedOption
              ? 'dropdown__selected-label_visible'
              : ''
          ]"
          [innerHtml]="cleanHtml(steps['LOOKING_FOR'].selectedOption?.term)"
        ></p>
        <ul class="dropdown__list" (click)="$event.stopPropagation()">
          <ng-container *ngFor="let data of wayfinderMatrixJson">
            <li
              *ngIf="
                data.parent_target_id === steps['SERVICE'].selectedOption?.tid
              "
              class="dropdown__list-item"
              (click)="selectOption('LOOKING_FOR', data)"
              (mouseenter)="steps['LOOKING_FOR'].hoveredOption = data"
              (mouseleave)="steps['LOOKING_FOR'].hoveredOption = null"
              [innerHtml]="cleanHtml(data.term)"
            ></li>
          </ng-container>
        </ul>
      </div>

      <digital-platform-cta-button
        (click)="isFormValid && onGo()"
        [ngClass]=""
        [ctaSize]="defaultButtonSize"
        [ctaStyle]="defaultButtonStyle"
        [isButtonDisabled]="!isFormValid"
        data-automation-id="wayfinder-submit-button"
        >Go</digital-platform-cta-button
      >
    </div>
  </div>
</div>
